
import React, { Component, PropTypes } from 'react';
import { ControlLabel } from 'react-bootstrap';
import Select from './Select';

const hours = [];
for (let i = 0; i <= 24; i++) {
  hours.push({ value: `${i}`, label: `${i}` });
}

const minutes = [];
for (let i = 0; i <= 59; i+=5) {
  minutes.push({ value: `${i}`, label: `${i}` });
}

class SelectTime extends Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(key, value) {
    const time = { ...this.props.value };
    time[key] = Number(value);
    this.props.onChange(time);
  }

  render() {
    const xs = typeof this.props.xs === 'number' ? Math.floor(this.props.xs / 2) : 6;
    const sm = typeof this.props.sm === 'number' ? Math.floor(this.props.sm / 2) : 6;
    const md = typeof this.props.md === 'number' ? Math.floor(this.props.md / 2) : 6;
    const lg = typeof this.props.lg === 'number' ? Math.floor(this.props.lg / 2) : 6;

    return (
      <div className="pt-control-group">
        <Select
          xs={xs}
          sm={sm}
          md={md}
          lg={lg}
          controlId={`${this.props.controlId}Hour`}
          label="Stunde"
          placeholder="Stunde wählen"
          options={hours}
          value={this.props.value.hour}
          validationState={this.props.validationState}
          onChange={(e) => this.onChange('hour', e.target.value)}
        />
        <Select
          xs={xs}
          sm={sm}
          md={md}
          lg={lg}
          controlId={`${this.props.controlId}Minute`}
          label="Minute"
          placeholder="Minute wählen"
          options={minutes}
          value={this.props.value.minute}
          validationState={this.props.validationState}
          onChange={(e) => this.onChange('minute', e.target.value)}
        />
      </div>
    );
  }
}

Select.propTypes = {
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  controlId: PropTypes.string,
  validationState: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.string,
  })),
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
}

export default SelectTime;



/** WEBPACK FOOTER **
 ** ./src/form/SelectTime.js
 **/